import { __ } from '~/locale';
import { referenceQueries } from '../../queries/constants';
import CopyableField from './copyable_field.vue?vue3';
export default {
    name: 'SidebarReferenceWidget',
    components: {
        CopyableField
    },
    inject: [
        'fullPath',
        'iid'
    ],
    props: {
        issuableType: {
            required: true,
            type: String
        }
    },
    emits: [
        'fetch-error'
    ],
    data () {
        return {
            reference: ''
        };
    },
    apollo: {
        reference: {
            context: {
                batchKey: 'MRSidebarData'
            },
            query () {
                return referenceQueries[this.issuableType].query;
            },
            variables () {
                return {
                    fullPath: this.fullPath,
                    iid: this.iid
                };
            },
            update (data) {
                return data.namespace?.issuable?.reference || '';
            },
            error (error) {
                this.$emit('fetch-error', {
                    message: __('An error occurred while fetching reference'),
                    error
                });
            }
        }
    },
    computed: {
        isLoading () {
            return this.$apollo.queries.reference.loading;
        }
    }
};
